import { FormEventHandler, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import logo from "../../assets/images/tlp-logo-white.png";
import { toast } from "react-toastify";
import { FcGoogle } from "react-icons/fc";
import { getGoogleUrl } from "../../utils/getGoogleUrl";
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
import { api } from "../../utils/apiClient";

const Register = () => {
  const [name, setName] = useState("");
  const [nameFieldEmpty, setNameFieldEmpty] = useState(false);
  const [email, setEmail] = useState("");
  const [emailFieldEmpty, setEmailFieldEmpty] = useState(false);
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [passwordFieldEmpty, setPasswordFieldEmpty] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPasswordFieldEmpty, setConfirmPasswordFieldEmpty] =
    useState(false);
  const [loading, setLoading] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [passwordWeak, setPasswordWeak] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  let from = ((location.state as any)?.from?.pathname as string) || "/";

  const togglePasswordVisibility = () => {
    setPasswordShown(!passwordShown);
  };

  const toggleConfirmPasswordVisibility = () => {
    setConfirmPasswordShown(!confirmPasswordShown);
  };

  const registerHandler: FormEventHandler = async (e) => {
    e.preventDefault();

    const emailFormat =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    if (!name) {
      setNameFieldEmpty(true);
      return;
    } else {
      setNameFieldEmpty(false);
    }

    if (!email || !email.match(emailFormat)) {
      setEmailFieldEmpty(true);
      return;
    } else {
      setEmailFieldEmpty(false);
    }

    if (!password) {
      setPasswordFieldEmpty(true);
      return;
    } else {
      setPasswordFieldEmpty(false);
    }

    if (password.length < 6) {
      setPasswordWeak(true);
      return;
    } else {
      setPasswordWeak(false);
    }

    if (!confirmPassword) {
      setConfirmPasswordFieldEmpty(true);
      return;
    } else {
      setConfirmPasswordFieldEmpty(false);
    }

    if (password !== confirmPassword) {
      setPassword("");
      setConfirmPassword("");
      setPasswordError(true);
      return;
    } else {
      setPasswordError(false);
    }

    setLoading(true);
    localStorage.setItem("registration-email", email.toLowerCase());

    try {
      await api({
        method: "POST",
        url: "/api/auth/register",
        data: { name, email, phone, password },
      });

      setLoading(false);
      navigate("/verify-account");
    } catch (error: any) {
      setLoading(false);
      toast.error(error.message);
    }
  };

  const googleHandler = () => {
    try {
      window.location.href = getGoogleUrl(from);
    } catch (error) {
      toast.error("Something went wrong");
    }
  };

  return (
    <div
      className="fancybox-container flq-fancybox-signin fancybox-is-open flq-fancybox-open"
      role="dialog"
      tabIndex={-1}
      id="fancybox-container-1"
      style={{ transitionDuration: "1000ms" }}
    >
      <div className="fancybox-inner">
        <div className="fancybox-stage">
          <div className="fancybox-slide fancybox-slide--html fancybox-slide--current fancybox-slide--complete">
            <div
              className="flq-fancybox-content-signin fancybox-content"
              id="flq_popup_signin"
              style={{ display: "inline-block" }}
            >
              <div className="flq-signin">
                <div className="flq-fancybox-head">
                  <div className="container-fluid">
                    <Link to="/" className="flq-fancybox-brand me-auto">
                      <img src={logo} className="flq-logo" alt="logo" />
                    </Link>
                  </div>
                </div>
                <div className="flq-fancybox-body pb-6">
                  <form
                    onSubmit={registerHandler}
                    className="flq-signup-content"
                  >
                    <h4 className="mb-4 pb-1 text-center">Register</h4>
                    <div className="row gy-4">
                      <div className="col-12">
                        <input
                          className="form-control flq-form-user flq-form-translucent"
                          type="text"
                          name="name"
                          placeholder="Full name"
                          value={name}
                          onChange={(e) => {
                            setName(e.target.value);
                            setNameFieldEmpty(false);
                          }}
                        />
                        {nameFieldEmpty && (
                          <p
                            className="text-danger mt-1 text-center"
                            style={{ fontSize: "15px" }}
                          >
                            This field is required
                          </p>
                        )}
                      </div>
                      <div className="col-12">
                        <input
                          className="form-control flq-form-mail flq-form-translucent"
                          type="email"
                          name="email"
                          placeholder="Email"
                          value={email}
                          onChange={(e) => {
                            setEmail(e.target.value.toLowerCase());
                            setEmailFieldEmpty(false);
                          }}
                        />
                        {emailFieldEmpty && (
                          <p
                            className="text-danger mt-1 text-center"
                            style={{ fontSize: "15px" }}
                          >
                            Please enter a valid email address
                          </p>
                        )}
                      </div>
                      <div className="col-12">
                        <input
                          className="form-control flq-form-phone flq-form-translucent"
                          type="tel"
                          name="phone"
                          placeholder="Phone"
                          value={phone}
                          onChange={(e) => {
                            setPhone(e.target.value);
                          }}
                        />
                      </div>
                      <div className="col-12" style={{ position: "relative" }}>
                        <input
                          className="form-control flq-form-lock flq-form-translucent"
                          type={`${passwordShown ? "text" : "password"}`}
                          placeholder="Password"
                          value={password}
                          onChange={(e) => {
                            setPassword(e.target.value);
                            setPasswordFieldEmpty(false);
                            setPasswordError(false);
                            setPasswordWeak(false);
                          }}
                        />
                        <a
                          href="#/"
                          onClick={togglePasswordVisibility}
                          style={{
                            position: "absolute",
                            right: "30px",
                            top: "8px",
                          }}
                        >
                          {!passwordShown ? (
                            <IoEyeOutline />
                          ) : (
                            <IoEyeOffOutline />
                          )}
                        </a>
                        {passwordFieldEmpty && (
                          <p
                            className="text-danger mt-1 text-center"
                            style={{ fontSize: "15px" }}
                          >
                            This field is required
                          </p>
                        )}
                        {passwordWeak && (
                          <p
                            className="text-danger mt-1 text-center"
                            style={{ fontSize: "15px" }}
                          >
                            Password should be at least 6 characters long
                          </p>
                        )}
                      </div>
                      <div className="col-12" style={{ position: "relative" }}>
                        <input
                          className="form-control flq-form-lock flq-form-translucent"
                          type={`${confirmPasswordShown ? "text" : "password"}`}
                          placeholder="Confirm Password"
                          value={confirmPassword}
                          onChange={(e) => {
                            setConfirmPassword(e.target.value);
                            setConfirmPasswordFieldEmpty(false);
                            setPasswordError(false);
                            setPasswordWeak(false);
                          }}
                        />
                        <a
                          href="#/"
                          onClick={toggleConfirmPasswordVisibility}
                          style={{
                            position: "absolute",
                            right: "30px",
                            top: "8px",
                          }}
                        >
                          {!confirmPasswordShown ? (
                            <IoEyeOutline />
                          ) : (
                            <IoEyeOffOutline />
                          )}
                        </a>
                        {confirmPasswordFieldEmpty && (
                          <p
                            className="text-danger mt-1 text-center"
                            style={{ fontSize: "15px" }}
                          >
                            This field is required
                          </p>
                        )}
                        {passwordError && (
                          <p
                            className="text-danger mt-1 text-center"
                            style={{ fontSize: "15px" }}
                          >
                            Passwords do not match
                          </p>
                        )}
                      </div>
                      <div className="col-12">
                        <div className="form-check flq-form-translucent">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="signupTerms"
                            required
                          />
                          <label
                            className="form-check-label"
                            htmlFor="signupTerms"
                          >
                            I have read and agree to Thinklikeapianist's{" "}
                            <Link to="/privacy-policy">Privacy Policy</Link> and{" "}
                            <Link className="text-gold" to="/terms-of-use">
                              Terms of Use
                            </Link>
                          </label>
                        </div>
                      </div>
                      <div className="col-12">
                        {loading ? (
                          <button
                            className="btn btn-block"
                            style={{ background: "#c79200" }}
                            disabled
                          >
                            Registering...
                          </button>
                        ) : (
                          <button
                            className="btn btn-block"
                            style={{ background: "#c79200" }}
                          >
                            Register
                          </button>
                        )}
                      </div>

                      <div className="col-12 text-center mt-1">or</div>
                      <div className="col-12 mt-1">
                        <div className="row justify-content-center gy-1">
                          <div className="col-12">
                            <button
                              onClick={googleHandler}
                              className="btn btn-sm btn-block btn-white btn-icon-sm"
                              type="button"
                              style={{ width: "100%", fontSize: "15px" }}
                            >
                              <FcGoogle
                                style={{
                                  marginRight: "4px",
                                }}
                              />
                              Register with Google
                            </button>
                          </div>
                        </div>
                      </div>

                      <div
                        className="col-12 mt-3 text-center"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        Already have an account?{" "}
                        <Link
                          to="/login"
                          className="btn btn-link"
                          style={{ marginLeft: "5px" }}
                        >
                          {" "}
                          Login
                        </Link>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
